import { IVariable } from "../../interfaces/IVariable";
import { createTheme, Theme } from "@mui/material/styles";
import { darkenColor } from "../../util/helpers";
import { getlocalStorageIdHotsite } from "../../util/LocalStorage";

// UrlLoja:"https://prd-ecommerce-und-api.primecase.com.br/api"

let idHotsiteLocalStorage = getlocalStorageIdHotsite();

export const variables: IVariable = {
  IdHotsite: idHotsiteLocalStorage,
  Loja: "quatrocantos",
  UserStorage: "OwNk3qAjPk6KcAyFZ1JjUw==",
  UserToken: "856Sb0oBn0egKmdcErTiVg==",
  UrlApi: "https://prd-ecommerce-qct-api.primecase.com.br/api",
  UrlLoja: "https://prd-ecommerce-qct-web.primecase.com.br",
  UrlServiceHost: "https://dev2-pri-sgc-api.primecase.com.br/",
  OrgId: "",
  ProviderMerchantId: ""
};

export const template: Theme = createTheme({
  palette: {
    primary: {
      main: "#e89a11",
      light: "#B799F2",
      //lighter: "#ece6f7",
      dark: darkenColor("#e89a11", 10), // Escurece em 20%
    },
    secondary: {
      main: "#7E7296",
    },
    error: {
      main: "#a91c1c",
    },
    text: {
      primary: "#222",
      //light: "#fff",
    },
    warning: {
      main: "#ff9800",
    },
    // white: {
    //   main: "#fff",
    // },
  },

  typography: {
    subtitle1: {
      fontSize: 12,
    },
    body1: {
      fontSize: 14,
    },
  },
});
